var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "3no5zzx6aa",
    d: "M7.5 0C11.636 0 15 3.364 15 7.5c0 1.843-.668 3.533-1.775 4.84l6.592 6.593c.244.244.244.64 0 .884-.122.122-.282.183-.442.183-.16 0-.32-.061-.442-.183l-6.593-6.592C11.033 14.332 9.343 15 7.5 15 3.364 15 0 11.636 0 7.5S3.364 0 7.5 0zm0 1.25c-3.446 0-6.25 2.804-6.25 6.25s2.804 6.25 6.25 6.25 6.25-2.804 6.25-6.25-2.804-6.25-6.25-6.25z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qi6hnkupfb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3no5zzx6aa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#3no5zzx6aa"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D6DCE8",
    mask: "url(#qi6hnkupfb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.11ac9e2cefbfc69b12f51927cd91baa1.svg";
export { ForwardRef as ReactComponent };